export default function TeamCalendar() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Calendar Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
